export const PAGE_TYPE_OPTIONS = [
  { value: 'DONATION', label: 'Donation Page' },
  { value: 'EVENT', label: 'Event Page' },
  { value: 'RECOMMENDATION', label: 'Recommendation Page' },
];

export const LAYOUT_OPTIONS = [
  { value: 'IMAGE_LEFT', label: 'Image Left' },
  { value: 'IMAGE_RIGHT', label: 'Image Right' },
  { value: 'IMAGE_CENTER_TOP', label: 'Image Center Top' },
  { value: 'IMAGE_CENTER_BOTTOM', label: 'Image Center Bottom' },
  { value: 'NO_IMAGE', label: 'No Image' },
];

export const RECOMMENDED_DIMENSIONS = {
  IMAGE_LEFT: 'Upload Image. Recommended size: 1090px x 1090px.',
  IMAGE_RIGHT: 'Upload Image. Recommended size: 1090px x 1090px.',
  IMAGE_CENTER_TOP: 'Upload Image. Recommended size: 1940px x 1090px.',
  IMAGE_CENTER_BOTTOM: 'Upload Image. Recommended size: 1940px x 1090px.',
  NO_IMAGE: '',
};

export const showButtonOptions = [
  { value: true, label: 'Show Button' },
  { value: false, label: 'Hide Button' },
];
